import { MDBBtn, MDBIcon, MDBModalFooter } from 'mdb-react-ui-kit'
import React, { forwardRef, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from 'react-router';
import { getMisc } from '../../../../apiclients/streamsapi_bridge';
import { getMultiSelectRequest, setMultiSelectValue } from '../../misc/MultiSelectRequest';
import PopupLoader from '../../PopupLoader';
import MultiSaveLimitAlert from '../../../../apiclients/MultiSaveLimitAlert';
const ChangeSeatPlan = forwardRef((props, ref) => {
  const [selectedRegion, setSelectedRegion] = useState("IN");
  const { t, i18n } = useTranslation();
  const [services, setservices] = useState([]);
  const [serviceId, setserviceId] = useState(-1);
  const [selectedSuite, setSelectedSuite] = useState("--");
  const [selectedPrice, setSelectedPrice] = useState("0.0");
  const [restrictAddon, setrestrictAddon] = useState(false);
  const [showWarning, setShowWarning] = useState(false);
  const warningToggle = () => setShowWarning(!showWarning);
  const [saveWarningMessage, setsaveWarningMessage] = useState("");
  const [allEntriesDicard, setAllEntriesDicard] = useState(false);

  const navigate = useNavigate();
  const [error, setError] = useState("");
  const [warningMsg, setwarningMsg] = useState([]);

  useEffect(() => {
    getServicePlan();

  }, []);
  async function getServicePlan() {
    props.setIsloading(true);
    const tdata = await getMultiSelectRequest(6, props.agentList, props.moduleType);
    props.setIsloading(false);
    if (!tdata) {
      window.alert(`info with id  not found`);
      navigate("/");
    }

    setservices(tdata?.result?.option_list ?? []);
    setwarningMsg(tdata?.result?.message ? [tdata?.result?.message] : []);

  }

  function changeService(e) {
    try {
      setSelectedSuite(services.filter((item) => parseInt(item.id) === parseInt(e.target.value))[0].name);
      setSelectedPrice(
        services.filter((item) => parseInt(item.id) === parseInt(e.target.value))[0].price
      );
    } catch (ex) {
      setSelectedSuite("--");
      setSelectedPrice("0.0");
      //alert(e);
    }
  }

  async function handleChangePlan(value) {
    props.setIsloading(true);
    const tdata = await setMultiSelectValue(6, value + "", props.agentList, props.moduleType, null, restrictAddon);
    props.setIsloading(false);
    if (!tdata) {
      window.alert(`info with id  not found`);
      navigate("/");
    }
    console.log("handlePermissionRoleChange for multi select ::::::::::::: " + JSON.stringify(tdata));
    const reponseMsg = tdata.display_info ?? [];
    if (reponseMsg.length > 0) {
      setwarningMsg(reponseMsg);
    }
  }

  async function onsubmit(confirmFlag) {
    if (parseInt(serviceId) === -1) {
      setError("Please select a Service Plan");
      return;
    }
    props.setIsloading(true);
    let tdata = null;
    if (confirmFlag) {
      tdata = await setMultiSelectValue(6, serviceId + "", props.agentList, props.moduleType, 1, 1, restrictAddon);
    } else {
      tdata = await setMultiSelectValue(6, serviceId + "", props.agentList, props.moduleType, 1, null, restrictAddon);
    }
    props.setIsloading(false);
    if (!tdata) {
      window.alert(`info with id  not found`);
      navigate("/");
    }
    if (tdata.status == "Failed") {
      localStorage.setItem(
        "user_create_f",
        "Something went wrong, Please try again after sometime"
      );
      props.onClose();
      window.location.href = "/userlanding";
    } else if (tdata.status == "failed") {
      if (tdata.exceededErrMsg) {
        setsaveWarningMessage(tdata.exceededErrMsg);
        if(tdata.all_grps_discarded) {
                    setAllEntriesDicard(true);
                }
        warningToggle();
        return;
      }
    } else {
      console.log("serviceId for multi select ::::::::::::: " + JSON.stringify(tdata));
      localStorage.setItem("s_message", tdata.message);

      if (props.locUser) {
        navigate("/locationsusers", {
          state: { tab: props.locUser },
        });

      } else if (props.groupInfo) {
        navigate("/usersgroups", {
          state: { tab: props.groupInfo },
        });

      } else if (props.groupUInfo) {
        navigate("/SelectedUserGroupSettings", {
          state: { tab: "tab2", groupUInfo: props.groupUInfo },
        });
      } else if (props.usergroups) {
        navigate("/userlanding", {
          state: { tab: "mgroups" },
        });

      } else if (props.userLoc) {
        navigate("/userlanding", {
          state: { tab: "suser", tab2: "sloc" },
        });

      } else if (props.userAllgroups) {
        navigate("/userlanding", {
          state: { tab: "suser", tab2: "sgroups" },
        });



      } else {
        navigate("/userlanding", {
          state: { tab: "suser", tab2: "suser" },
        });
      }
      props.onClose();

      window.location.reload();
    }

  }

  return (
    <>
      <div className="w-100" style={{ paddingBottom: 125 }}>
        <div>
          <strong className=" d-block">
            {t("SeatPlan")}
          </strong>
          <select
            className="form-select form-control mt-2 w-100"
            value={serviceId}
            onChange={(e) => {
              setserviceId(e.target.value);
              changeService(e);
              if (parseInt(e.target.value) === -1) {
                setError("Please select a Service Plan");
              } else {
                setError("");
                handleChangePlan(e.target.value);
              }
            }}
          >
            <option value={-1}>-- Select Service Plan --</option>
            {services &&
              services.map((item) => (
                <>
                  <option key={item.id} value={item.id}>
                    {item.name}
                  </option>
                </>
              ))}
          </select>
          {error && (
            <p className="text-danger">{error}</p>
          )}
        </div>
        {warningMsg && warningMsg.length > 0 && warningMsg.map((meg) => (
          <div className="pt-2 phrecording">
            {meg}
          </div>
        ))}
        <div className='my-3 d-flex align-items-start '>
          <input type='checkbox' label="" checked={restrictAddon} id='restrictAddon' className='mt-1' onClick={(e) => setrestrictAddon(e.target.checked)} />
          <label htmlFor='restrictAddon' className='ps-2 cursor-pointer lh-normal'>Do not purchase any extra addon(s) while changing the service plan.</label>
        </div>

      </div>
        <div style={{ display: "none" }}>
          <button ref={ref} onClick={(e) => {
            e.preventDefault();
            onsubmit();
          }}>
            {t("add")}</button>
        </div>
      {showWarning && (
        <>
          <PopupLoader
            title="Warning"
            content={
              <MultiSaveLimitAlert
                saveWarningMessage={saveWarningMessage}
                onClose={warningToggle}
                handleClick={() => { if(allEntriesDicard) {warningToggle(); props.onClose(); return;}onsubmit(1);}}
              />
            }
            onShow={setShowWarning}
            onClose={warningToggle}
          />

        </>
      )}
    </>
  )
});

export default ChangeSeatPlan
